import { CommandContribution } from '@patsnap/tahiti-core';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { UsageLimitModalCommandHandler } from './services/commands/usage-limit-modal.commands';

/**
 * UsageLimitModal 功能模块
 * 提供用量限制弹窗命令
 */
export const usageLimitModalModule = (bind: interfaces.Bind) => {
    bind(CommandContribution).to(UsageLimitModalCommandHandler);
};

export {
    UsageLimitModalCommandHandler,
};
export type {
    OpenUsageLimitModalPayload,
    UsageLimitModalResult,
} from './services/commands/usage-limit-modal.commands';
export {
    appendUsageLimitUpgradeContextToUrl,
    getUsageLimitUpgradeUrl,
    inferUsageLimitAgentName,
    jumpToUsageLimitUpgradePage,
    resolveUsageLimitUpgradeContext,
} from './utils/usage-limit-upgrade';
export type {
    GetUsageLimitUpgradeUrlOptions,
    JumpToUsageLimitUpgradePageOptions,
    UsageLimitUpgradeContext,
    UsageLimitUpgradeContextOptions,
    UsageLimitUpgradeHeaderType,
} from './utils/usage-limit-upgrade';
